import React from 'react'
// @ts-ignore
import { Facebook, InstagramSquare, TwitterSolid, Youtube, Tiktok } from '@netbasequid/core'
import { Theme } from 'features/ui/types'
import { Source } from 'enums'

// eslint-disable-next-line import/prefer-default-export
export const getDomainIcon = (name: string | undefined, theme: Theme) => {
  switch (name) {
    case Source.TWITTER:
      return <TwitterSolid mode={theme} />
    case Source.FACEBOOK:
      return <Facebook mode={theme} />
    case Source.INSTAGRAM:
      return <InstagramSquare mode={theme} />
    case Source.YOU_TUBE:
      return <Youtube mode={theme} />
    case Source.TIKTOK:
      return <Tiktok mode={theme} />
    case Source.OTHER:
    default:
      return null
  }
}
